import * as setsHeadSales from './list';
import * as setsOrders from './orders';

const reducers = {
  ...setsHeadSales,
  ...setsOrders,
};

export default reducers;
